export default __webpack_public_path__ + "assets/MicrogrammaD-MediExte.b0c7c14f.svg";